import type { ReactNode } from "react";
import type { Center } from "../types/center.types";
import { useCenter } from "../hooks/centers.hooks";

type CenterTextProps = {
	id: number | string | undefined;
	format: (center: Center) => string | ReactNode;
};

const CenterText = ({ id, format }: CenterTextProps) => {
	const { data: center, isLoading } = useCenter(id);

	if (isLoading || center === null || center === undefined) {
		return <>--</>;
	}
	return format(center);
};

export default CenterText;
